import { render } from "./Prices.vue?vue&type=template&id=52ea749e&scoped=true"
import script from "./Prices.vue?vue&type=script&lang=js"
export * from "./Prices.vue?vue&type=script&lang=js"

import "./Prices.vue?vue&type=style&index=0&id=52ea749e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52ea749e"]])

export default __exports__